// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b78dcc25","389":"ced0f984","453":"545c23fb","732":"a08448be","977":"93a8c4e6"}[chunkId] + ".chunk.js";
};